import { useId, useRef } from "react";
import { useTranslation } from "react-i18next";

import useDialogAccessibility from "../../hooks/useDialogAccessibility";

const CampaignDialog = ({
  children,
  description,
  isOpen,
  onClose,
  title,
  titleEyebrow,
  wide = false,
}) => {
  const { t } = useTranslation();
  const dialogRef = useRef(null);
  const titleId = useId();

  useDialogAccessibility({
    closeDisabled: false,
    containerRef: dialogRef,
    initialFocusRef: null,
    isOpen,
    onClose,
  });

  if (!isOpen) return null;

  return (
    <div className="campaign-dialog-overlay" onMouseDown={onClose}>
      <div
        aria-labelledby={titleId}
        aria-modal="true"
        className={`campaign-dialog${wide ? " campaign-dialog-wide" : ""}`}
        ref={dialogRef}
        role="dialog"
        tabIndex="-1"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <header className="campaign-dialog-header">
          <div>
            <p>{titleEyebrow}</p>
            <h2 id={titleId}>{title}</h2>
          </div>
          <button
            aria-label={t("common.close")}
            className="campaign-dialog-close"
            type="button"
            onClick={onClose}
          >
            ×
          </button>
        </header>
        {description && <p className="campaign-dialog-description">{description}</p>}
        {children}
      </div>
    </div>
  );
};

export default CampaignDialog;
